<template>
  <div :id="componentId" class="spm1-review" :style="{ backgroundColor }">
    <div class="spm1-review-gallery">
      <img class="spm1-review-arrow spm1-review-arrow-left" referrerpolicy="no-referrer" src="../../../special/SpecialOne/assets/img/FigmaDDSSlicePNG99bb8919a69e1287d3f76ac4a83127c7.png" @click="prev" />
      <div class="spm1-review-track">
        <div
          v-for="(item, idx) in items"
          :key="idx"
          class="spm1-review-item"
          :class="getItemClass(idx)"
          @click="handleClick(item)"
        >
          <img class="spm1-review-image" referrerpolicy="no-referrer" :src="item.imageUrl" />
        </div>
      </div>
      <img class="spm1-review-arrow spm1-review-arrow-right" referrerpolicy="no-referrer" src="../../../special/SpecialOne/assets/img/FigmaDDSSlicePNG33a817cb60e4551109bd46ed91b16c20.png" @click="next" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileReviewSection',
  props: {
    componentId: {
      type: String,
      default: 'sp_one_module_11'
    }
  },
  data() {
    return {
      activeIndex: 3,
      backgroundColor: '#FFFFF0',
      items: [
        { imageUrl: require('../../../special/SpecialOne/assets/img/review_banner.png'), jumpType: 1, linkAddress: '' },
        { imageUrl: require('../../../special/SpecialOne/assets/img/review_banner.png'), jumpType: 2, linkAddress: 'https://www.example.com/review/2' },
        { imageUrl: require('../../../special/SpecialOne/assets/img/review_banner.png'), jumpType: 1, linkAddress: '' },
        { imageUrl: require('../../../special/SpecialOne/assets/img/review_banner.png'), jumpType: 2, linkAddress: 'https://www.example.com/review/4' },
        { imageUrl: require('../../../special/SpecialOne/assets/img/review_banner.png'), jumpType: 1, linkAddress: '' },
        { imageUrl: require('../../../special/SpecialOne/assets/img/review_banner.png'), jumpType: 2, linkAddress: 'https://www.example.com/review/6' },
        { imageUrl: require('../../../special/SpecialOne/assets/img/review_banner.png'), jumpType: 1, linkAddress: '' }
      ]
    }
  },
  methods: {
    prev() {
      this.activeIndex = (this.activeIndex - 1 + this.items.length) % this.items.length
    },
    next() {
      this.activeIndex = (this.activeIndex + 1) % this.items.length
    },
    handleClick(item) {
      if (item.jumpType !== 2 || !item.linkAddress) return
      window.open(item.linkAddress, '_blank')
    },
    getItemClass(idx) {
      const diff = idx - this.activeIndex
      if (diff === 0) return 'active'
      if (Math.abs(diff) === 1) return 'side'
      return 'hidden'
    }
  }
}
</script>

<style scoped>
.spm1-review {
  width: 100%;
  padding: 16px 8px;
  box-sizing: border-box;
}

.spm1-review-gallery {
  position: relative;
  width: 100%;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.spm1-review-track {
  position: relative;
  width: 100%;
  height: 100%;
}

.spm1-review-item {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 80%;
  height: 180px;
  margin-top: -90px;
  transform: translateX(-50%);
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  transition: all 0.4s ease;
}

.spm1-review-item.active {
  z-index: 10;
  opacity: 1;
}

.spm1-review-item.side {
  z-index: 5;
  opacity: 0.6;
  transform: translateX(-50%) scale(0.8);
}

.spm1-review-item.hidden {
  opacity: 0;
  pointer-events: none;
}

.spm1-review-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.spm1-review-arrow {
  position: absolute;
  top: 50%;
  width: 24px;
  height: 24px;
  margin-top: -12px;
  z-index: 30;
  cursor: pointer;
}

.spm1-review-arrow-left {
  left: 0;
}

.spm1-review-arrow-right {
  right: 0;
}
</style>
